/**
 * THE BOUNTY ICON (Nick, 8 Oct). Every bounty a member sees wears 🎯 — the strip, its
 * page, the invite, the inbox row, the email, /points — so the mark itself says "bounty"
 * wherever it turns up. A bounty's own `emoji` is an admin-list label only; members never
 * see it.
 */
export const BOUNTY_MARK = '🎯';
